import script from "./EvTripDamageReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./EvTripDamageReport.vue?vue&type=script&lang=ts&setup=true"

import "./EvTripDamageReport.vue?vue&type=style&index=0&id=74478b62&scoped=true&lang=css"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74478b62"]])

export default __exports__